import env from '@/config/env'
import api from './api'

export default {
  list(params) {
    return api.get('/admin/import-csvs', { params })
  },
  show(id, params) {
    return api.get(`/admin/import-csvs/${id}`, { params })
  },
  importPeople(params) {
    return api.post('/admin/csv-imports/people', params)
  },
  downloadTemplateURL() {
    return `${env.apiURL}/csv/modelo-csv-importacao-de-usuarios.csv`
  },
}
